import useSWR from "swr";
import { getFetcher } from "../services/api";

export default function useListPic({ companyId }) {
    const { data, isLoading, mutate } = useSWR(
        companyId 
            ? `/api/company/search-data-pic?companyIds=${companyId}` 
            : null, 
            getFetcher
    );

    return { dataPIC: data, isLoadingDataPIC: isLoading, mutatePIC: mutate };
}